import { ApplicationRef,
  ComponentRef,
  createComponent,
  Directive,
  ElementRef,
  EnvironmentInjector,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  Output,
  Renderer2,
  TemplateRef } from '@angular/core';
import { MpModalComponent } from './mp-modal.component';

@Directive({
  selector: '[mpOpenModal]',
  standalone: true
})
export class MpModalDirective {

  @Input() public mpOpenModal: TemplateRef<HTMLElement>;
  @Input() public mpModalTitle: string;
  @Input() public mpModalData: unknown;
  @Input() public mpModalBackdrop: boolean = false;
  @Input() public mpClickableModalBackdrop: boolean = false;
  @Input() public mpClosable: boolean = true;
  @Input() public mpShowCloseButton: boolean = true;
  @Input() public mpShowCancelButton: boolean = true;
  @Input() public mpDisplayHeader: boolean = true;
  @Input() public mpDisplayFooter: boolean = true;
  @Input() public mpDisplayFooterTopBorder: boolean = true;
  @Input() public mpMode: 'centered' | 'sidenav' | 'floating' | 'from-bottom' = 'centered';
  @Input() public mpModalSaveLabel: string = 'GLOBAL.SAVE';
  @Input() public mpModalCancelLabel: string = 'GLOBAL.CANCEL';
  @Input() public mpOpenOnClickEnabled: boolean = true;

  @Output() public cancelModal = new EventEmitter<void>();

  private componentRef: ComponentRef<MpModalComponent>;

  constructor(private readonly elementRef: ElementRef,
              private readonly renderer2: Renderer2,
              private readonly applicationRef: ApplicationRef,
              private readonly envInjector: EnvironmentInjector,
              private readonly ngZone: NgZone) {
  }

  @HostListener('keydown.enter', ['$event'])
  @HostListener('click', ['$event'])
  onPageClick(event: Event): void {
    this.ngZone.runOutsideAngular(() => {
      if (!this.mpOpenOnClickEnabled) {
        return;
      }

      if (!this.componentRef && this.elementRef.nativeElement.contains(event.target)) {
        this.ngZone.run(() => this.openModal());
      }
    });
  }

  @HostListener('document:keydown.escape')
  removeModal(): void {
    if (!this.componentRef) {
      return;
    }
    this.applicationRef.detachView(this.componentRef.hostView);
    this.componentRef.destroy();
    this.componentRef = undefined;
    this.cancelModal.emit();
  }

  private openModal() {
    this.componentRef = createComponent(MpModalComponent, { environmentInjector: this.envInjector });
    this.applicationRef.attachView(this.componentRef.hostView);
    this.setMenuComponentInputs();
    this.renderer2.appendChild(document.body, this.componentRef.location.nativeElement);
  }

  private setMenuComponentInputs() {
    if (!this.componentRef) {
      return;
    }

    this.componentRef.instance.mpModalService.close = this.removeModal.bind(this);

    this.componentRef.setInput('anchor', this.elementRef);
    this.componentRef.setInput('mpModal', this.mpOpenModal);
    this.componentRef.setInput('mpModalTitle', this.mpModalTitle);
    this.componentRef.setInput('mpModalData', this.mpModalData);
    this.componentRef.setInput('mpMode', this.mpMode);
    this.componentRef.setInput('mpModalSaveLabel', this.mpModalSaveLabel);
    this.componentRef.setInput('mpModalCancelLabel', this.mpModalCancelLabel);
    this.componentRef.setInput('removeModal', this.removeModal.bind(this));
    this.componentRef.setInput('mpClosable', this.mpClosable);
    this.componentRef.setInput('mpShowCloseButton', this.mpShowCloseButton);
    this.componentRef.setInput('mpShowCancelButton', this.mpShowCancelButton);
    this.componentRef.setInput('mpDisplayHeader', this.mpDisplayHeader);
    this.componentRef.setInput('mpDisplayFooter', this.mpDisplayFooter);
    this.componentRef.setInput('mpDisplayFooterTopBorder', this.mpDisplayFooterTopBorder);
    this.componentRef.setInput('mpModalBackdrop', this.mpModalBackdrop);
    this.componentRef.setInput('mpClickableModalBackdrop', this.mpClickableModalBackdrop);
  }
}
